import { render, staticRenderFns } from "./ImportStep2.vue?vue&type=template&id=52452c04&"
import script from "./ImportStep2.vue?vue&type=script&lang=js&"
export * from "./ImportStep2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports